<template>
  <div>
    <div class="mb-2">
      <a href="#" @click.prevent="$router.go(-1)" class="">
        <i class="bi bi-arrow-left-short icon-sm"></i> Go back
      </a>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-4">
        <div class="card shadow-sm rounded">
          <div class="card-body">
            <div v-if="loading" class="text-center py-4 text-muted">
              <span class="spinner-border spinner-border-sm mr-2"></span>
              Loading program...
            </div>
            <template v-else>
            <h4 class="font-weight-bold mb-2">
              {{ localProgram.program_name }}
            </h4>
            <span
              v-if="localProgram.former_name"
              class="form-text text-muted mb-3"
              >Former Name: {{ localProgram.former_name }}</span
            >
            <p class="mb-0">
              Program ID: <strong>{{ localProgram.id }}</strong>
            </p>
            <p class="mb-0">
              Discipline Code:
              <strong> {{ localProgram.discipline_code }} </strong>
            </p>
            <p class="mb-0">
              Level Code: <strong>{{ localProgram.level_code }}</strong>
            </p>

            <div class="d-flex justify-content-end">
              <button
                v-if="
                  this.$store.state.user.role === 'Administrator' ||
                  this.$store.state.user.role === 'Supervisor'
                "
                class="btn btn-primary"
                @click="editProgram"
              >
                Edit Program
              </button>
            </div>
            </template>
          </div>
        </div>

        <ProgramReferencesTab v-if="localProgram.id" :program="localProgram"></ProgramReferencesTab>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
        <ProgramAreasOfEvaluationTab
          v-if="localProgram.id"
          :program="localProgram"
        ></ProgramAreasOfEvaluationTab>
      </div>
    </div>

    <!-- Edit Program Modal -->
    <EditProgramModal
      ref="editProgramModal"
      @programUpdated="onProgramUpdated"
    />
  </div>
</template>

<script>
import ProgramReferencesTab from "./ProgramReferencesTab.vue";
import ProgramAreasOfEvaluationTab from "./ProgramAreasOfEvaluationTab.vue";
import EditProgramModal from "../components/EditProgramModal.vue";

export default {
  name: "ProgramDetails",
  components: {
    ProgramReferencesTab,
    ProgramAreasOfEvaluationTab,
    EditProgramModal,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    program: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localProgram: this.program ? { ...this.program } : {},
      loading: false,
    };
  },
  watch: {
    program: {
      handler(newProgram) {
        if (newProgram && newProgram.id) {
          this.localProgram = { ...newProgram };
        }
      },
      deep: true,
    },
    id(newId) {
      if (newId && (!this.localProgram || !this.localProgram.id)) {
        this.loadProgram(newId);
      }
    },
  },
  methods: {
    previousRoute() {
      this.$router.go(-1);
    },

    loadProgram(id) {
      this.loading = true;
      axios
        .get(`api/programs/${id}`)
        .then((response) => {
          this.localProgram = response.data;
        })
        .catch(() => {
          toastr.error("Failed to load program details.", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editProgram() {
      this.$refs.editProgramModal.open(this.localProgram);
    },

    onProgramUpdated(updatedProgram) {
      // Validate that we have the updated program data
      if (!updatedProgram || !updatedProgram.id) {
        console.error("Invalid program data received:", updatedProgram);
        return;
      }

      // Update the local program data
      this.localProgram = { ...updatedProgram };

      // Update the program in the store
      if (this.$store.state.programs) {
        const index = this.$store.state.programs.findIndex(
          (p) => p.id === updatedProgram.id
        );
        if (index !== -1) {
          Object.assign(this.$store.state.programs[index], updatedProgram);
        }
      }

      // Reset the mount flag so Programs.vue will refresh next time
      this.$store.state.isProgramsMounted = false;
    },
  },
  mounted() {
    const routeId = this.id || this.$route.params.id;
    if (this.program && this.program.id) {
      this.localProgram = { ...this.program };
    } else if (routeId) {
      this.loadProgram(routeId);
    }
  },
};
</script>
